// PostHog for the public site and the staff site: pageviews and clicks everywhere, the signed-in
// staff member on the staff site, and explicit events around the chat. The staff site shows
// customer records, so session recording stays off, and events carry ids and counts, never text.
// Emulator and unknown environments send nothing.
import posthog from 'posthog-js';
import { firebaseEnvironment } from './firebase';

const KEYS = {
  production: 'phc_uz58MYqBgZaPqNDtK9RkTjDkq57JcGr3ezGmCACKiEQe',
  development: 'phc_wFiveNDbmSnWK9unkzzg2XPSYajEuJHPpv6SNcZHvhB4',
};
let enabled = false;

export function initAnalytics(site) {
  const key = KEYS[firebaseEnvironment];
  if (!key || enabled) return;
  posthog.init(key, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    disable_session_recording: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
  });
  posthog.register({ site, environment: firebaseEnvironment });
  enabled = true;
}

export function identifyStaff(user) {
  if (!enabled) return;
  if (user) posthog.identify(user.uid, { email: user.email || undefined, name: user.displayName || undefined });
  else posthog.reset();
}

export function track(event, properties = {}) {
  if (enabled) posthog.capture(event, properties);
}
